import React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { Button } from 'quantux-ui';
import { blue } from '../../theme';

const PayerSearchCard = (props) => {
  const { isNewPayer, payerName, payerCode, onAddPayer, onAddNewPayer } = props;

  const styles = StyleSheet.create({
    cardContainer: {
      background: blue[800],
      width: '359px',
      marginTop: '32px',
      fontSize: '14px',
      fontWeight: '700'
    },
    title: {
      marginLeft: '8px',
      color: blue[200]
    }
  });

  return (
    <div className={`p-2 ${css(styles.cardContainer)}`}>
      <div className='fx'>
        <svg
          width="64"
          height="64"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 4a4 4 0 0 1 4-4h56a4 4 0 0 1 4 4v56a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4Zm32.19 1.333-22.857 7.62V35.81c0 12.624 10.232 22.857 22.858 22.857 12.624 0 22.857-10.233 22.857-22.858V12.953L32.19 5.333Zm.006 49.054c10.256 0 18.572-8.316 18.572-18.572V16.174L32.196 9.625l-18.571 6.548v19.643c0 10.255 8.316 18.57 18.571 18.57Z"
            fill="#96C8FF"
          />
        </svg>
        <div className={css(styles.title)}>
          {payerName}
        </div>
      </div>
      {/* <div>
        <span className={css(styles.title)}>
          Payer Name:&nbsp;
        </span>
        {payerName}
      </div>
      <div>
        <span className={css(styles.title)}>
          Payer Code:&nbsp;
        </span>
        {payerCode}
      </div> */}
      <Button
        btnType='primary'
        isTextBtn
        onClick={() => {
          if (isNewPayer) {
            onAddNewPayer();
          } else {
            onAddPayer();
          }
        }}
        className='mt-2'
        style={{ width: '334px' }}
      >
        {isNewPayer ? 'Create Payer' : 'Add Payer'}
      </Button>
    </div>
  );
};

PayerSearchCard.defaultProps = {
  isNewPayer: false
};

export default PayerSearchCard;
